<template>
   <div>
       jello
       <Results></Results>
   </div>
</template>

<script>

import Results  from "@/components/metsankayttaja/Results";

export default {
    components: {
        Results
    }
}
</script>

<style>

</style>
